export const featureProperties = {
  NO_OF_FORMS: 'NO_OF_FORMS',
  NO_OF_SUBMISSIONS: 'NO_OF_SUBMISSIONS',
  HAS_ANSWERBASED: 'HAS_ANSWERBASED',
  HAS_VISITORBASED: 'HAS_VISITORBASED',
  HAS_SCOREBASED: 'HAS_SCOREBASED',
  FILE_UPLOAD_STORAGE: 'FILE_UPLOAD_STORAGE',
  FILE_SIZE_LIMIT: 'FILE_SIZE_LIMIT',
  NO_OF_LANDING_PAGES: 'NO_OF_LANDING_PAGES',
  NO_OF_AI_GENERATED_LANDING_PAGES: 'NO_OF_AI_GENERATED_LANDING_PAGES',
  ENABLE_TRUSTEDFORM: 'ENABLE_TRUSTEDFORM',
  ENABLE_SIGNATURE: 'ENABLE_SIGNATURE'
}
